
/*
|--------------------------------------------------------------------------
| Initial State
|--------------------------------------------------------------------------
*/
const initialState = {
  level: '',
  progress: null,
  section_id: '',
  section: {},
  section_data: {},
  lessons: [],
  lesson_data: {},
  lesson_content: {},
  lesson_modal: false,
  section_status: '',
  lesson_status: '',
  content_status: '',
};

/*
|--------------------------------------------------------------------------
| Mutations
|--------------------------------------------------------------------------
*/
const mutations = {
  setLevel(state, payload) {
    state.level = payload
  },
  unsetLevel(state, payload) {
    state.level = ''
  },
  setProgress(state, payload) {
    state.progress = payload
  },
  unsetProgress(state, payload) {
    state.progress = ''
  },
  setSection(state, payload) {
    state.section = payload
  },
  unsetSection(state, payload) {
    state.section = {}
  },
  setSectionData(state, payload) {
    if(Object.keys(payload).length) {
      state.section_data = Object.assign({}, state.section_data, payload)
    } else {
      state.section_data = {}
    }
  },
  unsetSectionData(state) {
    state.section_data.splice(0, state.section_data.length)
  },
  setLessons(state, payload) {
    state.lessons.splice(0, state.lessons.length)
    state.lessons = payload
  },
  unsetLessons(state, payload) {
    state.lessons.splice(0, state.lessons.length)
  },
  setLessonData(state, payload) {
    if(Object.keys(payload).length) {
      state.lesson_data = Object.assign({}, state.lesson_data, payload)
    } else {
      state.lesson_data = {}
    }
  },
  unsetLessonData(state) {
    state.lesson_data = {}
  },
  setLessonContent(state, payload) {
    if(Object.keys(payload).length) {
      state.lesson_content = Object.assign({}, state.lesson_content, payload)
    } else {
      state.lesson_content = {}
    }
  },
  updateLessonContentStatus(state, payload) {
    if(payload.type in state.lesson_content) {
      state.lesson_content[payload.type].status = payload.status
    }
  },
  unsetLessonContent(state) {
    state.lesson_content = {}
  },
  lessonModal(state, payload) {
    state.lesson_modal = payload
  },
  setSectionStatus(state, payload) {
    state.section_status = payload
  },
  unsetSectionStatus(state) {
    state.section_status = ''
  },
  setLessonStatus(state, payload) {
    state.lesson_status = payload
  },
  unsetLessonStatus(state) {
    state.lesson_status = ''
  },
  setContentStatus(state, payload) {
    state.content_status = payload
  },
  unsetContentStatus(state) {
    state.content_status = ''
  },
};

/*
|--------------------------------------------------------------------------
| Actions
|--------------------------------------------------------------------------
*/
const actions = {
  setLevel: (context, data) => {
    context.commit('setLevel', data)
  },
  unsetLevel: (context) => {
    context.commit('unsetLevel')
  },
  setProgress: (context, data) => {
    context.commit('setProgress', data)
  },
  unsetProgress: (context) => {
    context.commit('unsetProgress')
  },
  setSection: (context, data) => {
    context.commit('setSection', data)
  },
  unsetSection: (context) => {
    context.commit('unsetSection')
  },
  setSectionData: (context, data) => {
    context.commit('setSectionData', data)
  },
  unsetSectionData: (context) => {
    context.commit('unsetSectionData')
  },
  setLessons: (context, data) => {
    context.commit('setLessons', data)
  },
  unsetLessons: (context) => {
    context.commit('unsetLessons')
  },
  setLessonData: (context, data) => {
    context.commit('setLessonData', data)
  },
  unsetLessonData: (context) => {
    context.commit('unsetLessonData')
  },
  setLessonContent: (context, data) => {
    context.commit('setLessonContent', data)
  },
  updateLessonContentStatus: (context, data) => {
    context.commit('updateLessonContentStatus', data)
  },
  unsetLessonContent: (context) => {
    context.commit('unsetLessonContent')
  },
  lessonModal: (context, data) => {
    context.commit('lessonModal', data)
  },
  setSectionStatus: (context, data) => {
    context.commit('setSectionStatus', data)
  },
  unsetSectionStatus: (context) => {
    context.commit('unsetSectionStatus')
  },
  setLessonStatus: (context, data) => {
    context.commit('setLessonStatus', data)
  },
  unsetLessonStatus: (context) => {
    context.commit('unsetLessonStatus')
  },
  setContentStatus: (context, data) => {
    context.commit('setContentStatus', data)
  },
  unsetContentStatus: (context) => {
    context.commit('unsetContentStatus')
  },
};

/*
|--------------------------------------------------------------------------
| Getters
|--------------------------------------------------------------------------
*/
const getters = {
  level: (state) => {
    return state.level
  },
  progress: (state) => {
    return state.progress
  },
  section: (state) => {
    return (state.section && Object.keys(state.section).length) ? state.section : {}
  },
  section_data: (state) => {
    return state.section_data
  },
  lessons: (state) => {
    return state.lessons
  },
  lesson_data: (state) => {
    return state.lesson_data
  },
  lesson_content: (state) => {
    return state.lesson_content
  },
  content_id: (state) => (step) => {
    return state.lesson_content && state.lesson_content[step] ? state.lesson_content[step].content_id : null
  },
  lesson_modal: (state) => {
    return state.lesson_modal
  },
  section_status: (state) => {
    return state.section_status
  },
  lesson_status: (state) => {
    return state.lesson_status
  },
  content_status: (state) => {
    return state.content_status
  },
};

/*
|--------------------------------------------------------------------------
| Export the module
|--------------------------------------------------------------------------
*/
export default {
  state: initialState,
  mutations,
  actions,
  getters
}